var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-calendar__week"},_vm._l((_vm.dates),function(date){return _c('span',{staticClass:"d-calendar__dayname",domProps:{"innerHTML":_vm._s(date.format('dd, DD MMM'))}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }